import React from 'react';
import _ from 'lodash';

export default function TableBoolean(props) {
    const { value = false, text = null } = props;

    const iconClass =  value ? ('fa fa-' + 'check') : null;
    const valueText = _.isEmpty(text) ? null : `${'\u00A0'}${text}`;
    
    return (
        <span>
            {iconClass && 
                <>
                    <i className={iconClass}></i>{valueText}
                </>
            }
        </span>
    );
}
